import { useContext, useEffect, useState } from 'react';
import styles from './Card.module.css';
import { useTranslation } from 'react-i18next';
import { TabContext } from '../../../../../Context/TabContext';
import Indicator from '../../../../UI/Indicator/Indicator';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';
import useHttp from '../../../../../hooks/use-http';

const Card = ({
  klijent,
  handleOpenDetalView,
  handleIzmeni,
  handleDelete,
  handleDodajDelove,
  handleOpenDocumentView,
}) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { getData } = useHttp('');
  const [b64Slika, setB64Slika] = useState('');

  const vratiSlikuB64 = async () => {
    const config = {
      method: 'POST',
      url: 'Kupci/konvertovanje_base64_sa_id_kupca',
      data: { id: klijent.id },
    };
    const response = await getData(config);

    if (!response.includes('Nema')) {
      setB64Slika(response);
    }
  };

  useEffect(() => {
    vratiSlikuB64();
  }, []);

  return (
    <div className={styles.card} onClick={handleOpenDetalView}>
      <Indicator
        status={klijent.statusMasinaKlijenta}
        // active={klijent.statusMasinaKlijenta === 'Operativna'}
      />
      <img
        src={`data:image/png;base64,${b64Slika}`}
        alt="klijent"
        className={styles.image}
      />
      <h2>{klijent.nazivFirme}</h2>
      <p>
        {t('adress')}: {klijent.adresa}
      </p>
      <p>
        {t('contactTel')}: {klijent.kontaktTelefon}
      </p>
      <p style={{ fontWeight: 'bold' }}>
        {t('numberOfRobots')}: {klijent.brojRobota}
      </p>
      <p style={{ fontWeight: 'bold' }}>
        {t('numberOfMolds')}: {klijent.brojAlata}
      </p>
      <p
        style={{
          fontWeight: 'bold',
          color: klijent.vanUpotrebe > 0 ? 'red' : '', // Set color to red if greater than 0, otherwise default
        }}
      >
        {t('outoforder')}:{klijent.vanUpotrebe}
      </p>
      {/* <p style={{ fontWeight: 'bold' }}>
        {t('endOfWarrany')}: {formatDateFromDB(klijent.garancijaIstice)}
      </p> */}
      {/* <div className={styles.buttons}>
        <button
          onClick={(e) => handleIzmeni(e, klijent)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-edit ${styles.icon}`} />
          {t('editMachine')}
        </button>
        <button
          onClick={(e) => handleDodajDelove(e, klijent)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-cog ${styles.icon}`} />
          {t('addParts')}
        </button>
        <button
          onClick={() => handleNewService(klijent)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-plus ${styles.icon}`} />
          {t('newServiceRequest')}
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleOpenDocumentView();
          }}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-file ${styles.icon}`} />
          {t('documentation')}
        </button>
        <button
          onClick={handleOrderOverview}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-list-alt ${styles.icon}`} />
          {t('orderOverview')}
        </button>

        <button
          onClick={(e) => handleDelete(e, klijent)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-trash-alt ${styles.icon}`} />
          {t('deleteMachine')}
        </button>
      </div> */}
    </div>
  );
};

export default Card;
